import IconBreadcrumbs from "../custom-breadcrumb";
import {ServerNews} from "../server-news";

export const ServerNewsPage = () => {
    return (<>
        <IconBreadcrumbs name={"Server News"}/>
        <ServerNews/>
    </>)
}